import { CandidateApplicationData } from "@/modules/candidate/types/candidateApplication.types";

export const initialCandidateProfile: CandidateApplicationData = {
  fullName: "",
  email: "",
  phone: "",
  currentLocation: "",
  totalExperience: "",
  currentCompany: "",
  currentDesignation: "",
  highestQualification: "",
  currentSalary: "",
  expectedSalary: "",
  noticePeriod: "",
  linkedinUrl: "",
  portfolioUrl: "",
  skills: "",
};

export const MAX_RESUME_SIZE = 5 * 1024 * 1024;
export const ACCEPTED_RESUME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const ACCEPTED_RESUME_EXTENSIONS = [".pdf", ".doc", ".docx"];

export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;
export const MAX_RECORDING_SECONDS = 120;
export const ACCEPTED_VIDEO_TYPES = [
  "video/mp4",
  "video/webm",
  "video/quicktime",
  "video/x-msvideo",
  "video/avi",
];
export const ACCEPTED_VIDEO_EXTENSIONS = [".mp4", ".webm", ".mov", ".avi"];

export const getSupportedRecordingMimeType = () => {
  const candidateTypes = [
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=vp8,opus",
    "video/webm",
    "video/mp4",
  ];

  if (typeof MediaRecorder === "undefined") {
    return "";
  }

  return candidateTypes.find((type) => MediaRecorder.isTypeSupported(type)) ?? "";
};

export const applicationSteps: Array<{
  id: "resume-upload" | "profile-review" | "video-upload";
  title: string;
  shortTitle: string;
}> = [
  { id: "resume-upload", title: "Upload Resume", shortTitle: "Resume" },
  { id: "profile-review", title: "Review Profile", shortTitle: "Profile" },
  { id: "video-upload", title: "Video Introduction", shortTitle: "Video" },
];

export const ALREADY_APPLIED_MESSAGE =
  'You have already applied for a job. You cannot apply for another job. Please check your application status.';

export const isAlreadyAppliedErrorMessage = (
  message: unknown
): boolean => {
  if (typeof message !== 'string') {
    return false;
  }

  const normalizedMessage = message.toLowerCase();

  return (
    normalizedMessage.includes('already applied') ||
    normalizedMessage.includes(
      'cannot apply for another job'
    )
  );
};